<!-- Container principal da página  -->
<div class="component-main-container">
  <app-page-header parentTitle="{{ 'hardwares.hardware-label' | translate }}"
    pageTitle="{{ 'hardwares.generate-hardware-label' | translate }}">
  </app-page-header>

  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <app-register-form></app-register-form>

        <!-- Sessão de filtro de Hardwares -->
        <div class="form-fields-box" [ngClass]="!filterHardwares ? 'closed' : ''" [formGroup]="filterHardwareForm">
          <h2 (click)="filterHardwaresOpen()">
            {{ "hardwares.filter-hardware" | translate }}
          </h2>
          <hr [ngClass]="!filterHardwares ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label> {{ "hardwares.label-name" | translate }} </mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">2</div>
            <mat-form-field appearance="outline">
              <mat-label> {{ "hardwares.label-major" | translate }} </mat-label>
              <input matInput type="number" min="0" formControlName="major" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label> {{ "hardwares.label-minor" | translate }} </mat-label>
              <input matInput type="number" min="0" formControlName="minor" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>
                {{ "hardwares.label-revision" | translate }}
              </mat-label>
              <input matInput type="number" min="0" formControlName="revision" />
            </mat-form-field>
          </div>
          <div class="d-flex m-2">
            @if (!hardwaresLoading) {
            <button class="btn btn-success m-2 w-50" (click)="filterHardware(null)">
              {{ "hardwares.button-filter" | translate }}
            </button>
            }
            @if (!hardwaresLoading) {
            <button class="btn btn-secondary m-2 w-50" (click)="resetFilter()">
              {{ "hardwares.reset-button-filter" | translate }}
            </button>
            }
            @if (hardwaresLoading) {
            <mat-spinner [diameter]="30" class="ms-3"></mat-spinner>
            }
          </div>
        </div>

        <!-- Sessão para criar novo Hardware -->
        <div class="form-fields-box" [ngClass]="!registerHardwares ? 'closed' : ''" [formGroup]="createHardwareForm">
          <h2 (click)="registerHardwaresOpen()">
            {{ "hardwares.create-hardware" | translate }}
          </h2>
          <hr [ngClass]="!registerHardwares ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label> {{ "hardwares.label-name" | translate }} </mat-label>
              <input matInput formControlName="nameCreateForm" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">2</div>
            <div class="date-picker-input">
              <p-datepicker formControlName="releaseDateCreateForm" dateFormat="dd/mm/yy"
                placeholder="{{ 'hardwares.label-release-date' | translate }}" pInputMask="99/99/9999"
                appendTo="body" />
            </div>
          </div>

          <div class="form-step version">
            <div class="circle-number">3</div>
            <mat-form-field appearance="outline">
              <mat-label> {{ "hardwares.label-major" | translate }} </mat-label>
              <input matInput type="number" formControlName="majorCreateForm" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label> {{ "hardwares.label-minor" | translate }} </mat-label>
              <input matInput type="number" min="0" formControlName="minorCreateForm" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>
                {{ "hardwares.label-revision" | translate }}
              </mat-label>
              <input matInput type="number" min="0" formControlName="revisionCreateForm" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">4</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "hardwares.label-description" | translate }}
              </mat-label>
              <textarea matInput formControlName="descriptionCreateForm"></textarea>
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">5</div>
            @if (!hardwaresLoading) {
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "hardwares.label-compatible-firmware" | translate }}
              </mat-label>
              <mat-select value="default">
                <mat-option disabled value="default">
                  {{ selectedNewFirmwaresIdList.length }}
                  {{ "hardwares.selected-firmware" | translate }}
                </mat-option>
                @for (newFirmware of firmwaresList; track newFirmware) {
                <span class="d-flex justify-content-start align-items-center">
                  <mat-checkbox class="ms-2 me-2" (change)="filterSelectedFirmwares($event, newFirmware.id)"
                    class="ms-2 me-2">
                    {{ newFirmware.name }} ({{ newFirmware.version }})
                  </mat-checkbox>
                </span>
                }
              </mat-select>
            </mat-form-field>
            }
            @if (hardwaresLoading) {
            <mat-spinner [diameter]="30"></mat-spinner>
            }
          </div>

          <!-- Sessão para criar Firmware compatível -->
          <mat-accordion class="newFirmware" [formGroup]="createFirmwareForm">
            <mat-expansion-panel (opened)="panelOpenHardware = true" (closed)="panelOpenHardware = false">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ "hardwares.create-new-firmware" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="form-step">
                <div class="circle-number">1</div>
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{ "hardwares.label-name" | translate }}
                  </mat-label>
                  <input matInput formControlName="nameCreateFirmwareForm" />
                </mat-form-field>
              </div>

              <div class="form-step">
                <div class="circle-number">2</div>
                <div class="date-picker-input">
                  <p-datepicker formControlName="releaseDateCreateFirmwareForm" dateFormat="dd/mm/yy"
                    placeholder="{{ 'hardwares.label-release-date' | translate }}" pInputMask="99/99/9999"
                    appendTo="body" />
                </div>
              </div>

              <div class="form-step version">
                <div class="circle-number">3</div>
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{ "hardwares.label-major" | translate }}
                  </mat-label>
                  <input matInput type="number" min="0" title="{{ 'hardwares.title-major' | translate }}"
                    formControlName="majorCreateFirmwareForm" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>
                    {{ "hardwares.label-minor" | translate }}
                  </mat-label>
                  <input matInput type="number" min="0" title="{{ 'hardwares.title-minor' | translate }}"
                    formControlName="minorCreateFirmwareForm" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>
                    {{ "hardwares.label-revision" | translate }}
                  </mat-label>
                  <input matInput type="number" min="0" title="{{ 'hardwares.title-revision' | translate }}"
                    formControlName="revisionCreateFirmwareForm" />
                </mat-form-field>
              </div>

              <div class="form-step">
                <div class="circle-number">4</div>
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{ "hardwares.label-description" | translate }}
                  </mat-label>
                  <input matInput formControlName="descriptionCreateFirmwareForm" />
                </mat-form-field>
              </div>
              <button class="btn btn-success" (click)="createCompatibleFirmware()"
                [disabled]="createFirmwareForm.invalid">
                {{ "hardwares.button-save" | translate }}
              </button>
              @if (firmwaresLoading) {
              <mat-spinner [diameter]="30"></mat-spinner>
              }
            </mat-expansion-panel>
          </mat-accordion>
          <button class="btn btn-success" (click)="createHardware()" [disabled]="createHardwareForm.invalid">
            {{ "hardwares.button-save" | translate }}
          </button>
          @if (firmwaresLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    @if (length > 0) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')" [loadingData$]="fileLoading">
      </app-table-header>
      <div class="table-container mt-2 mt-lg-3 mt-xl-3">
        <p-table [value]="ELEMENT_DATA" [rows]="pageSize" [totalRecords]="length" dataKey="id" [paginator]="true"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="name">{{ "hardwares.label-name" | translate }}</th>
              <th pSortableColumn="version">{{ "hardwares.version-hardware" | translate }}</th>
              <th pSortableColumn="releaseDate">{{ "hardwares.label-release-date" | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>{{ row.name }}</td>
              <td>{{ row.version }}</td>
              <td>
                {{ row.releaseDate | date : "dd/mm/yyyy" }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    }
  </div>
</div>